<h1 mat-dialog-title>Niezgodny rodzaj płatności w koszyku</h1>
<mat-dialog-content>
  <p>W Twoim koszyku znajdują się aktualnie płatności innego typu.</p>
  <p>Aby dodać tę płatność konieczne jest opróżnienie koszyka</p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-button color="warn" [matDialogClose]="false">anuluj</button>
  <button mat-raised-button cdkFocusInitial color="primary" [matDialogClose]="true">opróżnij koszyk</button>
</mat-dialog-actions>
